import { PromoBar } from "../../Model/PromoBar/PromoBar";
import { OffersPromoRepository } from "../../Repository/OffersPromoRepository";


export interface GetPromoBarByIdUseCase {
  invoke: (id: number) => Promise<PromoBar | null>;
}

export class GetPromoBarById implements GetPromoBarByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getPromoBarById(id);
    return getData;
  }
}